import React, { useEffect, useMemo, useState } from 'react';
import httpClient from '../../../../services/httpClient';

export default function MallaForm({ form, setForm, mode = 'nuevo', loading, materiasRegistradas = [] }) {
  const [materias, setMaterias] = useState([]);
  const [docentes, setDocentes] = useState([]);
  const [materiasLoading, setMateriasLoading] = useState(false);
  const [docentesLoading, setDocentesLoading] = useState(false);
  /*
  const [materiaSearchTerm, setMateriaSearchTerm] = useState('');
  const [docenteSearchTerm, setDocenteSearchTerm] = useState('');
  */

  useEffect(() => {
    fetchMaterias();
    fetchDocentes();
  }, []);

  const fetchMaterias = async () => {
    setMateriasLoading(true);
    try {
      const response = await httpClient.get('/api/materias?activo=true');
      setMaterias(response);
    } catch (error) {
      console.error('Error al obtener materias:', error);
    } finally {
      setMateriasLoading(false);
    }
  };

  const fetchDocentes = async () => {
    setDocentesLoading(true);
    try {
      const response = await httpClient.get('/api/docentes?activo=true');
      setDocentes(response);
    } catch (error) {
      console.error('Error al obtener docentes:', error);
    } finally {
      setDocentesLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const materiasRegistradasSet = useMemo(() => {
    const ids = new Set();
    (materiasRegistradas || []).forEach((item) => {
      const materiaId = item?.materia_id ?? item?.materiaId;
      if (materiaId !== undefined && materiaId !== null) {
        ids.add(String(materiaId));
      }
    });
    return ids;
  }, [materiasRegistradas]);

  const materiasDisponibles = useMemo(() => {
    if (mode !== 'nuevo') return materias;
    return materias.filter((materia) => {
      const materiaId = String(materia.id);
      if (form.materia_id && String(form.materia_id) === materiaId) {
        return true;
      }
      return !materiasRegistradasSet.has(materiaId);
    });
  }, [materias, materiasRegistradasSet, mode, form.materia_id]);

  const modalidadOptions = [
    { value: 'presencial', label: 'Presencial' },
    { value: 'online', label: 'Online' },
  ];

  const formatMateriaLabel = (materia) => {
    const rawName = `${materia.nombre || ''}`.trim();
    const suffix = materia.sigla ? ` (${materia.sigla})` : '';
    const maxNameLength = 36;
    const trimmedName =
      rawName.length > maxNameLength ? `${rawName.slice(0, maxNameLength - 3)}...` : rawName;
    return `${trimmedName}${suffix}`.trim();
  };

  /*
  const normalizeText = (value) => {
    if (!value) return '';
    return value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const filteredMaterias = useMemo(() => {
    const raw = normalizeText(materiaSearchTerm.trim());
    if (!raw) return materias;
    const terms = raw.split(/\s+/).filter(Boolean);
    return materias.filter((materia) => {
      const label = normalizeText(`${materia.nombre || ''} ${materia.sigla || ''}`);
      return terms.every((term) => label.includes(term));
    });
  }, [materias, materiaSearchTerm]);

  const selectedMateria = useMemo(
    () => materias.find((materia) => String(materia.id) === String(form.materia_id)),
    [materias, form.materia_id]
  );
  const selectedMateriaLabel = selectedMateria
    ? `${selectedMateria.nombre} (${selectedMateria.sigla || 'N/A'})`
    : form.materia_id
      ? `Materia #${form.materia_id}`
      : '';

  const showResults =
    Boolean(materiaSearchTerm.trim()) && filteredMaterias.length > 0 && !form.materia_id;

  const handleSelectMateria = (materia) => {
    if (!materia) return;
    setForm({
      ...form,
      materia_id: String(materia.id),
    });
    setMateriaSearchTerm(materia.nombre || '');
  };

  const handleClearMateria = () => {
    setForm({
      ...form,
      materia_id: '',
    });
    setMateriaSearchTerm('');
  };

  const filteredDocentes = useMemo(() => {
    const raw = normalizeText(docenteSearchTerm.trim());
    if (!raw) return docentes;
    const terms = raw.split(/\s+/).filter(Boolean);
    return docentes.filter((docente) => {
      const label = normalizeText(`${docente.nombres || ''} ${docente.apellidos || ''}`);
      return terms.every((term) => label.includes(term));
    });
  }, [docentes, docenteSearchTerm]);

  const selectedDocente = useMemo(
    () => docentes.find((docente) => String(docente.id) === String(form.docente_id)),
    [docentes, form.docente_id]
  );
  const selectedDocenteLabel = selectedDocente
    ? `${selectedDocente.nombres || ''} ${selectedDocente.apellidos || ''}`.trim()
    : form.docente_id
      ? `Docente #${form.docente_id}`
      : '';

  const showDocenteResults =
    Boolean(docenteSearchTerm.trim()) && filteredDocentes.length > 0 && !form.docente_id;

  const handleSelectDocente = (docente) => {
    if (!docente) return;
    setForm({
      ...form,
      docente_id: String(docente.id),
    });
    const fullName = `${docente.nombres || ''} ${docente.apellidos || ''}`.trim();
    setDocenteSearchTerm(fullName);
  };

  const handleClearDocente = () => {
    setForm({
      ...form,
      docente_id: '',
    });
    setDocenteSearchTerm('');
  };
  */

  return (
    <form className="malla-form">
      {mode === 'nuevo' ? (
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Materia</label>
            <select
              name="materia_id"
              className="form-select"
              value={form.materia_id}
              onChange={handleChange}
              disabled={loading || materiasLoading || materiasDisponibles.length === 0}
            >
              <option value="">
                {materiasLoading
                  ? 'Cargando materias...'
                  : materiasDisponibles.length
                    ? '-- Selecciona una materia --'
                    : 'No hay materias disponibles'}
              </option>
              {materiasDisponibles.map((materia) => (
                <option
                  key={materia.id}
                  value={materia.id}
                  title={`${materia.nombre || ''}${materia.sigla ? ` (${materia.sigla})` : ''}`.trim()}
                >
                  {formatMateriaLabel(materia)}
                </option>
              ))}
            </select>
            <small className="text-muted d-block mt-1">
              Solo se muestran materias no registradas en el curso.
            </small>
          </div>

          <div className="col-md-6">
            <label className="form-label">Modalidad</label>
            <select
              name="modalidad"
              className="form-select"
              value={form.modalidad || 'presencial'}
              onChange={handleChange}
              disabled={loading}
            >
              {modalidadOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Busqueda anterior (mantener comentada para revertir)
          <div className="col-md-6">
            <label className="form-label">Buscar materia por nombre o sigla</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por nombre o sigla"
                value={materiaSearchTerm}
                onChange={(e) => setMateriaSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    fetchMaterias();
                  }
                }}
                disabled={loading || materiasLoading || Boolean(form.materia_id)}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={fetchMaterias}
                disabled={loading || materiasLoading || Boolean(form.materia_id)}
              >
                {materiasLoading ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                ) : (
                  <i className="bi bi-search" aria-hidden="true" />
                )}
              </button>
              {(materiaSearchTerm || form.materia_id) && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleClearMateria}
                  aria-label="Limpiar"
                >
                  <i className="bi bi-x-circle" aria-hidden="true" />
                </button>
              )}
            </div>
            <small className="text-muted d-block mt-1">
              Escribe para filtrar y selecciona una materia de la lista.
            </small>
            {materiasLoading && (
              <div className="text-muted small mt-2">Cargando materias...</div>
            )}
            {!materiasLoading && materiaSearchTerm && filteredMaterias.length === 0 && (
              <div className="text-muted small mt-2">Sin resultados para la busqueda.</div>
            )}
            {showResults && (
              <div className="mt-2">
                <small className="text-muted d-block mb-1">Resultados de la busqueda</small>
                <div className="list-group small malla-search-results">
                  {filteredMaterias.map((materia) => {
                    const metaClass = 'text-muted';
                    return (
                      <button
                        type="button"
                        key={materia.id}
                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-start"
                        onClick={() => handleSelectMateria(materia)}
                      >
                        <div className="me-2">
                          <div className="fw-semibold">{materia.nombre}</div>
                          <div className={metaClass}>{materia.sigla || 'Sin sigla'}</div>
                        </div>
                        <small className={metaClass}>#{materia.id}</small>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
            {form.materia_id && (
              <div className="border rounded bg-light p-3 mt-3 mb-0">
                <p className="mb-1 fw-semibold">Materia seleccionada</p>
                <small className="text-muted">{selectedMateriaLabel}</small>
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">Buscar docente por nombre o apellido</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por nombre o apellido"
                value={docenteSearchTerm}
                onChange={(e) => setDocenteSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    fetchDocentes();
                  }
                }}
                disabled={loading || docentesLoading || Boolean(form.docente_id)}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={fetchDocentes}
                disabled={loading || docentesLoading || Boolean(form.docente_id)}
                aria-label="Buscar"
              >
                {docentesLoading ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                ) : (
                  <i className="bi bi-search" aria-hidden="true" />
                )}
              </button>
              {(docenteSearchTerm || form.docente_id) && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleClearDocente}
                  aria-label="Limpiar"
                >
                  <i className="bi bi-x-circle" aria-hidden="true" />
                </button>
              )}
            </div>
            <small className="text-muted d-block mt-1">
              Puedes buscar por nombres, apellidos o ambos.
            </small>
            {docentesLoading && (
              <div className="text-muted small mt-2">Cargando docentes...</div>
            )}
            {!docentesLoading && docenteSearchTerm && filteredDocentes.length === 0 && (
              <div className="text-muted small mt-2">Sin resultados para la busqueda.</div>
            )}
            {showDocenteResults && (
              <div className="mt-2">
                <small className="text-muted d-block mb-1">Resultados de la busqueda</small>
                <div className="list-group small malla-search-results">
                  {filteredDocentes.map((docente) => {
                    const metaClass = 'text-muted';
                    return (
                      <button
                        type="button"
                        key={docente.id}
                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-start"
                        onClick={() => handleSelectDocente(docente)}
                      >
                        <div className="me-2">
                          <div className="fw-semibold">
                            {`${docente.nombres || ''} ${docente.apellidos || ''}`.trim() || 'Sin nombre'}
                          </div>
                          <div className={metaClass}>{docente.email || 'Sin correo'}</div>
                        </div>
                        <small className={metaClass}>#{docente.id}</small>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
            {form.docente_id && (
              <div className="border rounded bg-light p-3 mt-3 mb-0">
                <p className="mb-1 fw-semibold">Docente seleccionado</p>
                <small className="text-muted">{selectedDocenteLabel || 'Sin nombre'}</small>
              </div>
            )}
          </div>
          */}
        </div>
      ) : (
        <div className="mb-3">
          <label className="form-label">Docente</label>
          <select
            name="docente_id"
            className="form-select"
            value={form.docente_id || ''}
            onChange={handleChange}
            disabled={loading || docentesLoading}
          >
            <option value="">
              {docentesLoading ? 'Cargando docentes...' : 'Sin docente asignado'}
            </option>
            {docentes.map((docente) => {
              const fullName = `${docente.nombres || ''} ${docente.apellidos || ''}`.trim();
              return (
                <option key={docente.id} value={docente.id}>
                  {fullName || 'Sin nombre'}
                </option>
              );
            })}
          </select>
          <small className="text-muted d-block mt-1">
            Selecciona un docente o deja sin asignar.
          </small>

          <label className="form-label mt-3">Modalidad</label>
          <select
            name="modalidad"
            className="form-select"
            value={form.modalidad || 'presencial'}
            onChange={handleChange}
            disabled={loading}
          >
            {modalidadOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {/* Busqueda anterior (mantener comentada para revertir)
          <label className="form-label">Buscar docente por nombre o apellido</label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por nombre o apellido"
              value={docenteSearchTerm}
              onChange={(e) => setDocenteSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  fetchDocentes();
                }
              }}
              disabled={loading || docentesLoading || Boolean(form.docente_id)}
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={fetchDocentes}
              disabled={loading || docentesLoading || Boolean(form.docente_id)}
              aria-label="Buscar"
            >
              {docentesLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
              ) : (
                <i className="bi bi-search" aria-hidden="true" />
              )}
            </button>
            {(docenteSearchTerm || form.docente_id) && (
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleClearDocente}
                aria-label="Limpiar"
              >
                <i className="bi bi-x-circle" aria-hidden="true" />
              </button>
            )}
          </div>
          <small className="text-muted d-block mt-1">
            Puedes buscar por nombres, apellidos o ambos.
          </small>
          {docentesLoading && (
            <div className="text-muted small mt-2">Cargando docentes...</div>
          )}
          {!docentesLoading && docenteSearchTerm && filteredDocentes.length === 0 && (
            <div className="text-muted small mt-2">Sin resultados para la busqueda.</div>
          )}
          {showDocenteResults && (
            <div className="mt-2">
              <small className="text-muted d-block mb-1">Resultados de la busqueda</small>
              <div className="list-group small malla-search-results">
                {filteredDocentes.map((docente) => {
                  const metaClass = 'text-muted';
                  return (
                    <button
                      type="button"
                      key={docente.id}
                      className="list-group-item list-group-item-action d-flex justify-content-between align-items-start"
                      onClick={() => handleSelectDocente(docente)}
                    >
                      <div className="me-2">
                        <div className="fw-semibold">
                          {`${docente.nombres || ''} ${docente.apellidos || ''}`.trim() || 'Sin nombre'}
                        </div>
                        <div className={metaClass}>{docente.email || 'Sin correo'}</div>
                      </div>
                      <small className={metaClass}>#{docente.id}</small>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {form.docente_id && (
            <div className="border rounded bg-light p-3 mt-3 mb-0">
              <p className="mb-1 fw-semibold">Docente seleccionado</p>
              <small className="text-muted">{selectedDocenteLabel || 'Sin nombre'}</small>
            </div>
          )}
          */}
        </div>
      )}

      <div className="row mt-3">
        <div className="col-md-6 mb-3">
          <label htmlFor="horasInput" className="form-label">
            Horas de malla
          </label>
          <input
            id="horasInput"
            type="number"
            name="horas_malla"
            className="form-control"
            value={form.horas_malla}
            onChange={handleChange}
            placeholder="40.5"
            step="0.5"
            min="0"
            max="999.99"
            disabled={loading}
          />
          <small className="text-muted">Ej: 40.5</small>
        </div>

        <div className="col-md-6 mb-3">
          <label htmlFor="ordenInput" className="form-label">
            Orden
          </label>
          <input
            id="ordenInput"
            type="number"
            name="orden"
            className="form-control"
            value={form.orden}
            onChange={handleChange}
            placeholder="1"
            min="1"
            disabled={loading}
          />
          <small className="text-muted">Dejar en blanco para automático</small>
        </div>
      </div>

      <div className="mb-0 form-check form-switch">
        <input
          id="activoCheck"
          type="checkbox"
          name="activo"
          className="form-check-input"
          checked={form.activo}
          onChange={handleChange}
          disabled={loading}
        />
        <label htmlFor="activoCheck" className="form-check-label">
          Materia activa en el curso
        </label>
      </div>
    </form>
  );
}
